import { useQueries } from '@tanstack/react-query';

import { InternalServerError } from '@platform/core/errors';

import { capabilitiesQuery } from '@apis/capability/queries/capabilities';
import { systemCapabilitiesQuery } from '@apis/capability/queries/system-capabilities';
import { capabilitiesQuery as legacyCapabilitiesQuery } from '@apis/rendall/queries/capabilities';
import { organizationQuery } from '@apis/rendall/queries/organization';
import { subscriptionsQuery } from '@apis/rendall/queries/subscriptions';
import { userInfoQuery } from '@apis/rendall/queries/user-info';
import { useOrganizationParam } from '@packages/hooks/use-organization-param';

export const useOrganizationAccess = () => {
  const orgId = useOrganizationParam();

  const queries = useQueries({
    queries: [
      organizationQuery(orgId),
      capabilitiesQuery(orgId),
      userInfoQuery(),
      legacyCapabilitiesQuery(orgId),
      subscriptionsQuery(orgId),
      systemCapabilitiesQuery(),
    ],
    combine(result) {
      const errors = result?.filter((r) => r.status === 'error') ?? [];
      if (errors.length > 0) {
        // TODO: (S2CX-17110) Add checks for 403s and throw a ForbiddenError({reason: 'ACCESS_DENIED'}) once MAPIG has fixed it's CORS issues so that javascript is allowed to see the response status on 403s.
        throw new InternalServerError();
      }

      return {
        data: {
          organization: result[0].data,
          capabilities: result[1].data,
          userInfo: result[2].data,
          legacyCapabilities: result[3].data,
          subscriptions: result[4].data,
          systemCapabilities: result[5].data,
        },
        isLoading: result.some((r) => r.isLoading),
        isError: result.some((r) => r.isError),
        isFetching: result.some((r) => r.isFetching),
        isPending: result.some((r) => r.isPending),
      };
    },
  });

  return {
    ...queries,
    data: {
      ...queries.data,
      orgId,
    },
  };
};
